// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "blink-3dbb1.firebaseapp.com",
  "projectId": "blink-3dbb1",
  "storageBucket": "blink-3dbb1.firebasestorage.app",
  "messagingSenderId": "329197107359",
  "appId": "1:329197107359:web:13b90c9fd4ab7dfd7c0aaa",
  "measurementId": "G-F17Q68DNCT",
  "apiKey": "AIzaSyC2SoJW6ynrtyYa9JpApNwUX4yrfnGb86s"
};
